enum AttributeType {
  TEXTORNUMBER = 'TEXTORNUMBER',
  YEAR_RANGE = 'YEAR_RANGE',
  BI_TEXTORNUMBER = 'BI_TEXTORNUMBER'
}
export const searchableAttributes = {
  5:  {DISPLAY_NAME: 'Area Name',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['areaName'] },
  57: {DISPLAY_NAME: 'Book and Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['bookAndNumber'] },
  1:  {DISPLAY_NAME: 'County Name',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['countyName'] },
  22: {DISPLAY_NAME: 'Crown Plan Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['crownPlanNumber'] },
  24: {DISPLAY_NAME: 'Deed Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['deedNumber'] },
  58: {DISPLAY_NAME: 'Deed Receipt Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['deedReceiptNumber'] },
  6:  {DISPLAY_NAME: 'DP Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['dpNumber'] },
  13: {DISPLAY_NAME: 'Environs name',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['environsName'] },
  4:  {DISPLAY_NAME: 'Estate Name',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['estateName'] },
  10: {DISPLAY_NAME: 'Image Name',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['imageName'] },
  51: {DISPLAY_NAME: 'Index',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['index'] },
  41: {DISPLAY_NAME: 'Index Map',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['indexMap'] },
  43: {DISPLAY_NAME: 'Index Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['indexNumber'] },
  50: {DISPLAY_NAME: 'Location',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['location'] },
  7:  {DISPLAY_NAME: 'Map Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['mapNumber'] },
  8:  {DISPLAY_NAME: 'Map Reference',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['mapReference'] },
  61: {DISPLAY_NAME: 'Miscellaneous Register Number', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['miscellaneousRecord']},
  21: {DISPLAY_NAME: 'Notes',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['notes'] },
  2:  {DISPLAY_NAME: 'Parish Name',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['parishName'] },
  40: {DISPLAY_NAME: 'Pastoral Name',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['pastoralName'] },
  39: {DISPLAY_NAME: 'Pastoral Run Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['pastoralRunNumber'] },
  30: {DISPLAY_NAME: 'Plan',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['plan'] },
  29: {DISPLAY_NAME: 'Plan Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['planNumber'] },
  28: {DISPLAY_NAME: 'Plan Type',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['planType'] },
  59: {DISPLAY_NAME: 'Primary Application Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['primaryApplicationNumber'] },
  53: {DISPLAY_NAME: 'Serial and Page Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['serialAndPageNumber'] },
  52: {DISPLAY_NAME: 'Serial Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['serialNumber'] },
  56: {DISPLAY_NAME: 'Serial Number and Alpha',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['serialNumberAndAlpha'] },
  49: {DISPLAY_NAME: 'State Record Reference',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['stateRecordReference'] },
  44: {DISPLAY_NAME: 'Surname Initial',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['surnameInitial'] },
  3:  {DISPLAY_NAME: 'Town Name',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['townName'] },
  20: {DISPLAY_NAME: 'Vol-Fol',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['volFol'] },
  54: {DISPLAY_NAME: 'Year and Page Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['yearAndPageNumber'] },
  55: {DISPLAY_NAME: 'Year and Serial Number',TYPE: AttributeType.TEXTORNUMBER,FIELD_NAMES: ['yearAndSerialNumber'] },
  45: {DISPLAY_NAME: 'Year Range',TYPE: AttributeType.YEAR_RANGE,FIELD_NAMES: ['yearFrom', 'yearTo'] }
};

export const unsearchableAttributes = {
  36: {DISPLAY_NAME:'CD title', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['cdTitle']},
  18: {DISPLAY_NAME:'Date created', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['dateCreated']},
  19: {DISPLAY_NAME:'Date closed', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['dateClosed']},
  25: {DISPLAY_NAME:'Deed Type', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['deedType']},
  14: {DISPLAY_NAME:'District Office Name', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['districtOfficeName']},
  38: {DISPLAY_NAME:'Division', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['division']},
  16: {DISPLAY_NAME:'Edition number', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['editionNumber']},
  34: {DISPLAY_NAME:'Edition year', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['editionYear']},
  35: {DISPLAY_NAME:'File name', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['fileName']},
  42: {DISPLAY_NAME:'Map Number', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['mapNumber']},
  26: {DISPLAY_NAME:'Party 1', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['party_1']},
  27: {DISPLAY_NAME:'Party 2', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['party_2']},
  9:  {DISPLAY_NAME:'Scanning machine', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['scanningMachine']},
  11: {DISPLAY_NAME:'Scan timestamp', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['scanTimestamp']},
  37: {DISPLAY_NAME:'Sheet number', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['sheetNumber']},
  12: {DISPLAY_NAME:'Sheet reference', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['sheetReference']},
  17: {DISPLAY_NAME:'Sheet type', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['sheetType']},
  23: {DISPLAY_NAME:'Source office', TYPE: AttributeType.TEXTORNUMBER, FIELD_NAMES:['sourceOffice']}
};

export const collectionsMapping = {
  1: {
    NAME: 'Charting Maps',
    PARENT_COLLECTION_ID: null,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },
  2: {
    NAME: 'LTO Charting Maps',
    PARENT_COLLECTION_ID: 1,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },

  3: {
    NAME: 'County Map',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,10]
  },

  4: {
    NAME: 'Parish Map',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,2,10]
  },

  5: {
    NAME: 'Town Map',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [3,10]
  },

  6: {
    NAME: 'Estate Plan',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [4,6,10]
  },

  7: {
    NAME: 'VG Sheet',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [5,10]
  },

  8: {
    NAME: 'Wells',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [6,8,10]
  },

  9: {
    NAME: 'Litho',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [6,7,10]
  },

  10: {
    NAME: 'Norton',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [6,7,10]
  },

  11: {
    NAME: 'Armstrong',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [6,7,10]
  },

  12: {
    NAME: 'CMA Sheet',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [8,10]
  },

  13: {
    NAME: 'Roll Plan',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [6,8,10]
  },

  14: {
    NAME: 'City Section',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [6,8,10]
  },

  15: {
    NAME: 'Cumberland County Council Sheet',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [8,10]
  },

  16: {
    NAME: 'Deposited Plan',
    PARENT_COLLECTION_ID: 2,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [6,10]
  },

  17: {
    NAME: 'Status Branch Charting Maps',
    PARENT_COLLECTION_ID: 1,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },

  18: {
    NAME: 'County Map',
    PARENT_COLLECTION_ID: 17,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,10]
  },
  19: {
    NAME: 'Parish Map',
    PARENT_COLLECTION_ID: 17,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,2,10]
  },
  20: {
    NAME: 'Town Map',
    PARENT_COLLECTION_ID: 17,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [3,10]
  },
  21: {
    NAME: 'Environs Map',
    PARENT_COLLECTION_ID: 17,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [10,13]
  },
  22: {
    NAME: 'Regional Charting Maps',
    PARENT_COLLECTION_ID: 1,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },

  23: {
    NAME: 'County Map',
    PARENT_COLLECTION_ID: 22,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,6,10]
  },
  24: {
    NAME: 'Parish Map',
    PARENT_COLLECTION_ID: 22,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,2,6,10]
  },
  25: {
    NAME: 'Town Map',
    PARENT_COLLECTION_ID: 22,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [3,6,10]
  },
  26: {
    NAME: 'Environs Map',
    PARENT_COLLECTION_ID: 22,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [6,10,13]
  },
  27: {
    NAME: 'Pasturage Map',
    PARENT_COLLECTION_ID: 22,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [3,10]
  },
  28: {
    NAME: 'Administrative Map',
    PARENT_COLLECTION_ID: 22,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [10]
  },
  29: {
    NAME: 'Irrigation Map',
    PARENT_COLLECTION_ID: 22,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [8,10]
  },
  30: {
    NAME: 'Old Form Torrens Register',
    PARENT_COLLECTION_ID: null,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,20,21]
  },
  31: {
    NAME: 'Bridge Street Crown Plans',
    PARENT_COLLECTION_ID: 54,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,2,3,6,10,21,22]
  },
  32: {
    NAME: 'Irrigation Map',
    PARENT_COLLECTION_ID: 17,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [8,10]
  },
  33: {
    NAME: 'Pasturage Map',
    PARENT_COLLECTION_ID: 17,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [3,10]
  },
  34: {
    NAME: 'Old System Indexes',
    PARENT_COLLECTION_ID: 52,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },
  35: {
    NAME: 'St Mary MacKillop Deeds',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [1,2,3,10,21,24]
  },
  36: {
    NAME: 'Plan Lodgement Book',
    PARENT_COLLECTION_ID: null,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,28,29,30]
  },
  37: {
    NAME: 'Historical Parish Maps',
    PARENT_COLLECTION_ID: null,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },
  38: {
    NAME: 'Parish Maps',
    PARENT_COLLECTION_ID: 37,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,2,10]
  },
  39: {
    NAME: 'Town Maps',
    PARENT_COLLECTION_ID: 37,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [3,10]
  },
  40: {
    NAME: 'Pastoral Maps',
    PARENT_COLLECTION_ID: 37,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [10,39,40,41]
  },
  41: {
    NAME: 'County Maps',
    PARENT_COLLECTION_ID: 37,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,10]
  },
  42: {
    NAME: 'Grant Index',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,43,43,44]
  },
  43: {
    NAME: 'Anglican Primates',
    PARENT_COLLECTION_ID: 53,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,10,43,43]
  },
  44: {
    NAME: 'First Land Grant',
    PARENT_COLLECTION_ID: 53,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,10,43,43]
  },
  45: {
    NAME: 'Governors',
    PARENT_COLLECTION_ID: 53,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,10,43,43]
  },
  46: {
    NAME: 'Index Deeds Grant Issued of Town Allotments',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,10,43,43,44]
  },
  47: {
    NAME: 'Index of Land Purchase Forms 1860-1862',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,10,43,43]
  },
  48: {
    NAME: 'Newspaper Article',
    PARENT_COLLECTION_ID: 53,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,10,43,43]
  },
  49: {
    NAME: 'Settlements in NSW',
    PARENT_COLLECTION_ID: 53,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,10,43,43]
  },
  50: {
    NAME: 'Town Grants and Purchases',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,10,43,43,44]
  },
  51: {
    NAME: 'DP Mini Cards',
    PARENT_COLLECTION_ID: 1,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [6,10,28]
  },

  52: {
    NAME: 'Old System Records',
    PARENT_COLLECTION_ID: null,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },
  53: {
    NAME: 'Miscellaneous',
    PARENT_COLLECTION_ID: 52,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },
  54: {
    NAME: 'Crown Plans',
    PARENT_COLLECTION_ID: null,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },
  55: {
    NAME: 'State Records Crown Plans',
    PARENT_COLLECTION_ID: 54,
    SHOW_PARENT_COLLECTION: true,
    ATTRIBUTES: [1,2,3,10,22,49,50]
  },
  56: {
    NAME: 'Vendors Index',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,44,45,51]
  },
  57: {
    NAME: 'Purchasers Index',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,44,45,51]
  },
  58: {
    NAME: 'Torrens Purchasers Index 1863-1971',
    PARENT_COLLECTION_ID: null,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,44,45]
  },
  59: {
    NAME: 'Register of Land Grants and Leases',
    PARENT_COLLECTION_ID: 52,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: []
  },
  60: {
    NAME: 'Grant Register Supplementary Index',
    PARENT_COLLECTION_ID: 59,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,56]
  },
  61: {
    NAME: 'Grant Register',
    PARENT_COLLECTION_ID: 59,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,52,53,54,55]
  },
  62: {
    NAME: 'Grant Register Index of Pardons',
    PARENT_COLLECTION_ID: 59,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,52,53,54,55]
  },
  63: {
    NAME: 'Grant Register of Pardons',
    PARENT_COLLECTION_ID: 59,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,52,53,54,55]
  },
  64: {
    NAME: 'General Register of Deeds (Old System Deeds)',
    PARENT_COLLECTION_ID: null,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [57]
  },
  65: {
    NAME: 'Vendors Index (only Mac Mc)',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,44,45,51]
  },
  66: {
    NAME: 'Detailed Survey Sheet Index',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [3,10,51]
  },
  67: {
    NAME: 'Change of Name Index 1875-1967',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,44,45,51]
  },
  68: {
    NAME: 'Conditional Purchase Index',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,44,45,51]
  },
  69: {
    NAME: 'Deposited Deeds Index',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,44,45,51]
  },
  70: {
    NAME: 'Deposited Deeds Receipt Books',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,51,58]
  },
  71: {
    NAME: 'Primary Application Search Sketches',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,59]
  },
  72: {
    NAME: 'Primary Application Search Books',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,59]
  },
  73: {
    NAME: 'Primary Application Miscellaneous Search Books',
    PARENT_COLLECTION_ID: 34,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,59]
  },
  74: {
    NAME: 'Miscellaneous Register',
    PARENT_COLLECTION_ID: 59,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,61]
  },
  75: {
    NAME: 'Miscellaneous Register Index',
    PARENT_COLLECTION_ID: 59,
    SHOW_PARENT_COLLECTION: false,
    ATTRIBUTES: [10,44,45,51]
  }
};



// WEBPACK FOOTER //
// ./src/mappings.ts